<div class="container-fluid">
  <div class="row">
    <div class="col g-0">
      <div class="password-container">
        <input
          #passwordField
          type="password"
          [formControl]="passwordFormControl"
          class="form-control"
          placeholder="Password"
        />
        <i
          class="bi bi-eye-fill password-eye"
          (click)="toggleRevealPassword()"
        ></i>
      </div>
    </div>
  </div>
</div>
